import React from 'react';
import { createAndFireEvent, withAnalyticsContext, withAnalyticsEvents } from '@atlaskit/analytics-next';
import Field from './field';
var packageName = "@atlaskit/comment";
var packageVersion = "10.13.1";
var Author = function Author(_ref) {
  var children = _ref.children,
    href = _ref.href,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    onMouseOver = _ref.onMouseOver;
  return /*#__PURE__*/React.createElement(Field, {
    hasAuthor: true,
    href: href,
    onClick: onClick,
    onFocus: onFocus,
    onMouseOver: onMouseOver
  }, children);
};
Author.displayName = 'CommentAuthor';
export { Author as CommentAuthorWithoutAnalytics };
var createAndFireEventOnAtlaskit = createAndFireEvent('atlaskit');

/**
 * __Comment author__
 *
 * The author of the comment.
 */
var CommentAuthor = withAnalyticsContext({
  componentName: 'commentAuthor',
  packageName: packageName,
  packageVersion: packageVersion
})(withAnalyticsEvents({
  onClick: createAndFireEventOnAtlaskit({
    action: 'clicked',
    actionSubject: 'commentAuthor',
    attributes: {
      componentName: 'commentAuthor',
      packageName: packageName,
      packageVersion: packageVersion
    }
  })
})(Author));
export default CommentAuthor;